<template>
  <div
    class="biller-page company-detail-page page-content"
    :class="{
      'no-company-info': !company,
    }">
    <el-row class="reload-panel-holder" type="flex" justify="left" align="middle" v-if="!company">
      <el-col :span="24">
        <div class="reload-panel">
          <h3>ระบบไม่สามารถโหลดข้อมูลของบริษัทได้<br/>กรุณาลองใหม่อีกครั้ง</h3>
          <el-button type="primary" icon="el-icon-refresh" @click="reloadInfo">โหลดข้อมูลใหม่</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row class="page-header" type="flex" justify="space-between"  v-if="company">
      <el-col :span="24">
        <h2 class="page-title">รายละเอียดบริษัท</h2>
      </el-col>
    </el-row>

    <div class="company-detail-info" v-if="company">
      <el-row class="detail-section">
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              ชื่อบริษัท
            </el-col>
            <!--<el-col :span="12" class="label">
              Bill payment card name
            </el-col>-->
          </el-row>
          <el-row>
            <el-col :span="12">{{ company.name }}</el-col>
            <!--<el-col :span="12">{{ company.name_on_payment_card }}</el-col>-->
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              เลขประจำตัวผู้เสียภาษี
            </el-col>
            <el-col :span="12" class="label">
              เว็ปไซต์สำหรับจัดการของบริษัท
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ taxIdFormatter(company.tax_id) }}</el-col>
            <el-col :span="12">
              <code class="slug-host-code">{{ `${baseHost}/${company.slug}` }}</code>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="24" class="label">
              โลโก้บริษัท
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <img class="company-logo-preview" v-if="company.logo" :src="company.logo" :alt="company.name" />
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ที่อยู่หลักของบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="24" class="label">
              ที่อยู่
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">{{ company.address.line_1 }}</el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              อำเภอ/เขต
            </el-col>
            <el-col :span="12" class="label">
              ตำบล/แขวง
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ company.address.city }}</el-col>
            <el-col :span="12">{{ company.address.district }}</el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              จังหวัด
            </el-col>
            <el-col :span="12" class="label">
              รหัสไปรษณีย์
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ company.address.province }}</el-col>
            <el-col :span="12">{{ company.address.postal_code }}</el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              โทรศัพท์
            </el-col>
            <el-col :span="12" class="label">
              โทรสาร
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ telFormatter(company.address.tel) }}</el-col>
            <el-col :span="12">{{ faxFormatter(company.address.fax) }}</el-col>
          </el-row>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
  import { createMask } from 'imask';
  import helpers from '@/libs/helpers';

  const BillerCompanyDetailView = {
    name: 'biller-company-detail',
    data() {
      return {
        mask: {
          taxId: {
            mask: [
              { mask: '0000000000' },
              { mask: '0000000000000' },
            ],
          },
          tel: {
            mask: [
              { mask: '{02}-000-0000' },
              { mask: '{0}00-000-000' },
              { mask: '{0}00-000-0000' },
            ],
          },
          fax: {
            mask: [
              { mask: '{02}-000-0000' },
              { mask: '{0}00-000-000' },
            ],
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      company() {
        return this.$store.getters.billerInfo;
      },
      baseHost() {
        /* const hostName = window.location.hostname;
        const hosts = window.appConfig.BASE_HOST.splice(',');
        let currentHostName = '';
        hosts.forEach((host) => {
          if (hostName.indexOf(host) !== -1) {
            currentHostName = host;
          }
        });
        return currentHostName; */
        return helpers.getCurrentBaseHost();
        // return window.appConfig.BASE_HOST;
      },
    },
    methods: {
      reloadInfo() {
        this.$router.push({ name: 'BillerUserLoadInfo' });
      },
      telFormatter(val) {
        if (val) {
          return this.maskFormatter(val, this.mask.tel);
        }
        return '-';
      },
      faxFormatter(val) {
        if (val) {
          return this.maskFormatter(val, this.mask.fax);
        }
        return '-';
      },
      taxIdFormatter(val) {
        if (val) {
          return this.maskFormatter(val, this.mask.taxId);
        }
        return '-';
      },
      maskFormatter(val, maskOptions) {
        const mask = createMask(maskOptions);
        if (val) {
          return mask.resolve(val.toString());
        }
        return '';
      },
    },
  };
  export default BillerCompanyDetailView;
</script>

<style lang="scss">
  @import '../../assets/styles/color';
  .company-detail-page.no-company-info {
    height: 100%;
    .reload-panel-holder {
      height: 100%;
    }
    .reload-panel{
      text-align: center;
    }
  }
  .biller-page {
    &.company-detail-page {
      .company-logo-preview {
        max-width: 200px;
      }
    }
  }
  /* .company-detail-info {
    .company-logo-preview {
      max-width: 300px;
    }
    .detail-section {
      margin-bottom: 20px;
      border-bottom: 1px solid $color-secondary-purple;

      .section-title {
        margin: 20px 0;
      }
    }
    .detail-row {
      margin-bottom: 20px;

      .label {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
      }

      .slug-host-code {
        font-size: 16px;
      }
    }
  } */
</style>



// WEBPACK FOOTER //
// src/pages/biller/company-detail.vue